import _ from 'lodash';
import ah from '../utils/ajax-helper'; // get event type list

export var getTrafficEventTypeList = function getTrafficEventTypeList(contextRoot) {
  var noProgress = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  return new Promise(function (resolve, reject) {
    ah.get("".concat(contextRoot, "/traffic/event/type/list"), null, null, noProgress).then(function (result) {
      if (result.code < 0) throw new Error(result.error);
      resolve(result.data);
    }).catch(function (error) {
      reject(error);
    });
  });
}; // edit event type list

export var editEventTypeAPI = function editEventTypeAPI(contextRoot) {
  var noProgress = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var eventTypeList = arguments.length > 2 ? arguments[2] : undefined;
  return new Promise(function (resolve, reject) {
    ah.post("".concat(contextRoot, "/traffic/event/type/edit"), JSON.stringify(eventTypeList), null, noProgress).then(function (result) {
      if (result.code < 0) throw new Error(result.error);
      resolve();
    }).catch(function (error) {
      reject(error);
    });
  });
}; // get event traffic list

export var getTrafficEventList = function getTrafficEventList(contextRoot, noProgress) {
  var keyword = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
  var sort = arguments.length > 3 ? arguments[3] : undefined;
  var offset = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 0;
  var limit = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : null;
  var external = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : true;
  return new Promise(function (resolve, reject) {
    var sortField = sort ? sort.field : 'beginTime';
    var sortOrder = sort ? sort.desc ? 'desc' : 'asc' : 'asc';
    var requestParameters = {
      external: external,
      offset: offset,
      limit: limit,
      sort: sortField + ':' + sortOrder,
      keyword: keyword,
      isPublished: false,
      includeNotBegined: true
    };
    ah.get("".concat(contextRoot, "/traffic/event/list"), requestParameters, null, noProgress).then(function (result) {
      if (result.code < 0) throw new Error(result.error);
      resolve(result.data);
    }).catch(function (error) {
      reject(error);
    });
  });
}; // get event traffic list published

export var getTrafficEventListPublished = function getTrafficEventListPublished(contextRoot, noProgress) {
  var keyword = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
  var sort = arguments.length > 3 ? arguments[3] : undefined;
  var offset = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 0;
  var limit = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : null;
  return new Promise(function (resolve, reject) {
    var sortField = sort ? sort.field : 'beginTime';
    var sortOrder = sort ? sort.desc ? 'desc' : 'asc' : 'asc';
    var requestParameters = {
      isPublished: true,
      offset: offset,
      limit: limit,
      sort: sortField + ':' + sortOrder,
      keyword: keyword,
      includeNotBegined: true
    };
    ah.get("".concat(contextRoot, "/traffic/event/list"), requestParameters, null, noProgress).then(function (result) {
      if (result.code < 0) throw new Error(result.error);
      resolve(result.data);
    }).catch(function (error) {
      reject(error);
    });
  });
}; // create event

export var createEventAPI = function createEventAPI(contextRoot) {
  var noProgress = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var eventData = arguments.length > 2 ? arguments[2] : undefined;
  return new Promise(function (resolve, reject) {
    ah.post("".concat(contextRoot, "/traffic/event/create"), JSON.stringify(eventData), null, noProgress).then(function (result) {
      if (result.code < 0) throw new Error(result.error);
      resolve();
    }).catch(function (error) {
      reject(error);
    });
  });
}; // edit event

export var editEventAPI = function editEventAPI(contextRoot) {
  var noProgress = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var eventData = arguments.length > 2 ? arguments[2] : undefined;
  return new Promise(function (resolve, reject) {
    ah.post("".concat(contextRoot, "/traffic/event/edit"), JSON.stringify(eventData), null, noProgress).then(function (result) {
      if (result.code < 0) throw new Error(result.error);
      resolve();
    }).catch(function (error) {
      reject(error);
    });
  });
}; // delete event

export var deleteEventAPI = function deleteEventAPI(contextRoot) {
  var noProgress = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var eventData = arguments.length > 2 ? arguments[2] : undefined;
  return new Promise(function (resolve, reject) {
    ah.post("".concat(contextRoot, "/traffic/event/delete"), JSON.stringify(eventData), null, noProgress).then(function (result) {
      if (result.code < 0) throw new Error(result.error);
      resolve();
    }).catch(function (error) {
      reject(error);
    });
  });
}; // handle publish status

export var editEventPublishStatusAPI = function editEventPublishStatusAPI(contextRoot) {
  var noProgress = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var eventData = arguments.length > 2 ? arguments[2] : undefined;
  var isPublished = arguments.length > 3 ? arguments[3] : undefined;
  return new Promise(function (resolve, reject) {
    ah.post("".concat(contextRoot, "/traffic/event/isPublished/").concat(isPublished), JSON.stringify(eventData), null, noProgress).then(function (result) {
      if (result.code < 0) throw new Error(result.error);
      resolve();
    }).catch(function (error) {
      reject(error);
    });
  });
};